import { anxietyToolkitMetadata } from './metadata/anxietyToolkit'
import { cisGriefToolkitMetadata } from './metadata/cisGrief'
import { cisInjusticeToolkitMetadata } from './metadata/cisInjustice'
import { cisLossOfSafetyToolkitMetadata } from './metadata/cisLossOfSafety'
import { cisNaturalDisasterToolkitMetadata } from './metadata/cisNaturalDisaster'
import { cisPoliticalUncertaintyToolkitMetadata } from './metadata/cisPoliticalUncertainty'
import { confidenceToolkitMetadata } from './metadata/confidenceToolkit'
import { copingWithStressToolkitMetadata } from './metadata/copingWithStressToolkit'
import { familyToolkitMetadata } from './metadata/familyToolkit'
import { finishYearStrongToolkitMetadata } from './metadata/finishYearStrongToolkit'
import { googleOUSComingSoonMetadata } from './metadata/googleOUSComingSoon'
import { googlePerformanceMetadata } from './metadata/googlePerformance'
import { griefToolkitMetadata } from './metadata/griefToolkit'
import { holidayStressToolkitMetadata } from './metadata/holidayStressToolkit'
import { managerCoachingMetadata } from './metadata/managerCoaching'
import { mayMentalHealthToolkitMetadata } from './metadata/mayMentalHealthToolkit'
import { motivationToolkitMetadata } from './metadata/motivationToolkit'
import { neurodiversityToolkitMetadata } from './metadata/neurodiversityToolkit'
import { newYear2026ToolkitMetadata } from './metadata/newYear2026Toolkit'
import { newYearToolkitMetadata } from './metadata/newYearToolkit'
import { nicotineQuitlineMetadata } from './metadata/nicotineQuitline'
import { paidSocialToolkitMetadata } from './metadata/paidSocialToolkit'
import { parentalLeaveCoachingMetadata } from './metadata/parentalLeaveCoaching'
import { relationshipsToolkitMetadata } from './metadata/relationshipsToolkit'
import { resourceCoordinatorMetadata } from './metadata/resourceCoordinator'
import { thrivingAtWorkToolkitMetadata } from './metadata/thrivingAtWorkToolkit'
import { worldMentalHealthDayMetadata } from './metadata/worldMentalHealthDay'
import { CMSMicrositeMetadata } from './types'
import { UTM_CAMPAIGN, UTM_MEDIUM, UTM_SOURCE } from '../common/constants/utm'
export const ELECTION_UTM_CAMPAIGN = UTM_CAMPAIGN.ELECTION
export const ELECTION_UTM_SOURCE = UTM_SOURCE.HOMEBASE
export const ELECTION_UTM_MEDIUM = UTM_MEDIUM.PRODUCT

export const ELECTION_HOMEBASE_UTM_PARAMS = `utm_campaign=${ELECTION_UTM_CAMPAIGN}&utm_source=${ELECTION_UTM_SOURCE}&utm_medium=${ELECTION_UTM_MEDIUM}`

/** Complete list of all microsites that should use metadata format. In most cases, do not use this list directly; use `useActiveMicrositesMetadataList` instead. */
export const micrositesMetadataList: CMSMicrositeMetadata[] = [
  newYearToolkitMetadata,
  copingWithStressToolkitMetadata,
  neurodiversityToolkitMetadata,
  mayMentalHealthToolkitMetadata,
  relationshipsToolkitMetadata,
  motivationToolkitMetadata,
  familyToolkitMetadata,
  googleOUSComingSoonMetadata,
  griefToolkitMetadata,
  holidayStressToolkitMetadata,
  paidSocialToolkitMetadata,
  worldMentalHealthDayMetadata,
  cisNaturalDisasterToolkitMetadata,
  cisPoliticalUncertaintyToolkitMetadata,
  cisGriefToolkitMetadata,
  cisInjusticeToolkitMetadata,
  cisLossOfSafetyToolkitMetadata,
  finishYearStrongToolkitMetadata,
  newYear2026ToolkitMetadata,
  anxietyToolkitMetadata,
  thrivingAtWorkToolkitMetadata,
  confidenceToolkitMetadata,
]

/** Keep the most recent metadata in the list (the one with the highest index), for any that have the same micrositeUrl. This is to be used in cypress tests only -- in the app we would use `useActiveMicrositesMetadataList` instead. For tests, there's no way to determine which one is truly active since it's dependent on feature flags. */
export const micrositesMetadataListForTests = Array.from(
  micrositesMetadataList
    .reduce((map, item) => {
      map.set(item.micrositeUrl, item)
      return map
    }, new Map())
    .values(),
)

/** Secure microsites */
export const secureMicrositesMetadataList: CMSMicrositeMetadata[] = [
  googlePerformanceMetadata,
  parentalLeaveCoachingMetadata,
  resourceCoordinatorMetadata,
  managerCoachingMetadata,
  nicotineQuitlineMetadata,
]
